// Small display helpers shared by the phone Sales Orders screens. Layout only.
import { parseDueDate } from "../../../utils/dueDate";

/** A YYYY-MM-DD (or YYYY-MM-DDT00:00:00Z) date as a calendar day, "Oct 23". */
export const fmtDay = (d) => {
  const day = parseDueDate(d);
  return day ? day.toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "";
};

/** A timestamp (shipped at, staged at) as the local calendar day, "Oct 14": a shipment at 8 PM
 *  Central is still the 14th (fmtDay reads the UTC day of a timestamp). */
/** A shipment's day: shipped_date is a plain date ("2026-10-14", a calendar day), a finalized batch's
 *  pallet_batch_at a timestamp (its local day). */
export const fmtShipDay = (v) => (/^\d{4}-\d{2}-\d{2}$/.test(String(v || "")) ? fmtDay(v) : fmtLocalDay(v));

export const fmtLocalDay = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};
